import { createRouter, createWebHistory } from 'vue-router'
import { useScrollStore } from '@/stores/storeScroll'
import { useRequestsStore } from '@/stores/storeRequests';
import { useModals } from '@/utils/useModals'
import TheHomePage from '@/pages/TheHomePage.vue'
import TheNotFindPage from '@/pages/TheNotFindPage.vue'
import TheProfilePage from '@/pages/TheProfilePage.vue'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
			path: '/',
			name: 'home',
			component: TheHomePage,
        },
        {
			path: '/profile/',
			name: 'profile',
			component: TheProfilePage,
			meta: { requiresAuth: true }
        },
        {
			path: '/:pathMatch(.*)*',
			name: '404',
			component: TheNotFindPage,
        },
    ],
    scrollBehavior(to, from, savedPosition) {
		const storeScroll = useScrollStore();		
		const headerOffset = storeScroll.header?.offsetHeight || 100

		if (to.hash) {
			return {
				el: to.hash,
				behavior: 'smooth',
				top: headerOffset
			}
		}
		
		if (savedPosition) {
			return savedPosition
		}
		return { top: 0 }
    }
})

router.beforeEach((to, from, next) => { 
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const storeRequests = useRequestsStore();
	const { openModal } = useModals();	

	const { token, uuid, registration, recoverypassword } = to.query
	
	if (token && uuid && registration) {
		storeRequests.registrationAccept(token, uuid);
		router.replace({ path: to.path, query: {} });
	};
	if (token && uuid && recoverypassword) {
		openModal('newUserPassword', {
			token: token,
			uuid: uuid
		});
		router.replace({ path: to.path, query: {} });
	};
    if (requiresAuth && !storeRequests.isAuthenticated) {
      	next('/');
		
    } else {
      	next();
    }
	

});


export default router
